<template>
  <div class="container">
    <div class="row">
      <div
        class="col-xs-12 emergo-contact-pd"
        :class="!emergoContactBanner ? 'emergo-contact-removed' : ''"
      >
        <div class="emergo-contact ptb-10">
          <div class="row m-0">
            <div class="col-xs-12">
              <p class="country-representation">
                Are you an Emergo by UL in-country representation client?
              </p>
              <img
                @click="dismissTab()"
                src="/static/images/icons/close_blue_icon.svg"
                class="close-icon"
                alt="close-icon"
              />
            </div>
            <div class="col-xs-12 emergo-info">
              <div class="emergo-img">
                <img
                  class="emergo-imge"
                  alt="emergo-img"
                  src="/static/images/logos/emergo_logo.svg"
                />
              </div>
              <div class="active-account">
                <span>To activate your account,</span>
                <span class="fw-500"> Contact Emergo </span>
                <span>
                  to enjoy selected premium services free of cost or contact your organization to be
                  added as a team member to an existing account.</span
                >
              </div>
            </div>
            <div class="row col-xs-12 contact-emergo">
              <a @click="clearData" href="https://www.emergobyul.com/contact">Contact Emergo</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 crumb-selection">
      <ul class="crumb-trail">
        <li
          class="col-sm-4 p-0"
          v-for="(slide, index) in slidesInfo"
          :key="index"
          :class="{
            'is-active-slide col-xs-8': currentSlider === index,
            'col-xs-2': currentSlider !== index,
            completed_slide: currentSlider > index
          }"
        >
          <div class="crumb">
            <img
              src="/static/images/icons/circle_check.svg"
              class="breadcrumb-img"
              alt="check-icon"
            />
            <span>{{ slide.title }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-xs-12 p-0">
      <form @submit.prevent="submit" class="row m-0">
        <!-- Account Details -->
        <template v-if="currentSlider == 0">
          <div class="col-md-6 col-sm-6 col-xs-12 map-img">
            <img
              src="/static/images/logos/RAMS_Dashboard_Logo.png"
              class="rams-dashboard-logo"
              alt="rams-dashboard-logo"
            />
          </div>
          <div class="col-xs-12 col-md-6 col-sm-6 pl-0 xs-p-0">
            <div class="col-xs-12 account-details">
              <div class="info">Provide account details below:</div>
              <el-popover
                popper-append-to-body="false"
                placement="bottom-end"
                class="info-icon-class"
                trigger="click"
                popper-class="popup-background tootip-custom-small-width-class"
                @show="emailInfoActive = true"
                @hide="emailInfoActive = false"
              >
                <div class="content">
                  <ul class="word-break">
                    <li>
                      <span
                        >Please fill the mandatory details (if any) for all steps and they will be
                        available with “</span
                      >
                      <span class="mandatory-sign">*</span><span>” symbol.</span>
                    </li>
                    <li>
                      A unique email address is required and can be used to access a single RAMS
                      account. If your organization has an existing account, you will be restricted
                      from joining as long as your email address is associated with another active
                      account. Contact your organization to be added as a team member.
                    </li>
                    <li>
                      To reduce fraudulent account creation, public domain email addresses have been
                      restricted.
                    </li>
                  </ul>
                </div>
                <!-- <template #reference> -->
                <img
                  class="info-img"
                  src="/static/images/icons/info_icon.svg"
                  v-if="!emailInfoActive"
                  alt="info-icon"
                  slot="reference"
                />
                <img
                  class="info-img"
                  src="/static/images/icons/info_icon_active.svg"
                  v-if="emailInfoActive"
                  alt="infoactive-icon"
                  slot="reference"
                />
                <!-- </template> -->
              </el-popover>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="first-name">First Name</label>
              <span class="required_astric">*</span>
              <input
                id="first-name"
                class="form-control"
                :class="$v.user_data.first_name.$error ? 'invalid-border' : ''"
                v-model.trim="user_data.first_name"
                type="text"
                placeholder="First Name"
                maxlength="35"
                @blur="$v.user_data.first_name.$touch()"
              />
              <div v-if="$v.user_data.first_name.$error">
                <div class="custom-error-class" v-if="!$v.user_data.first_name.required">
                  Complete required field
                </div>
                <div class="custom-error-class" v-else-if="!$v.user_data.first_name.minLength">
                  Minimum 2 characters required.
                </div>
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="last-name">Last Name</label>
              <span class="required_astric">*</span>
              <input
                id="last-name"
                class="form-control"
                :class="$v.user_data.last_name.$error ? 'invalid-border' : ''"
                type="text"
                placeholder="Last Name"
                v-model.trim="user_data.last_name"
                maxlength="35"
                @blur="$v.user_data.last_name.$touch()"
              />
              <div v-if="$v.user_data.last_name.$error">
                <div class="custom-error-class" v-if="!$v.user_data.last_name.required">
                  Complete required field
                </div>
                <div class="custom-error-class" v-else-if="!$v.user_data.last_name.minLength">
                  Minimum 2 characters required.
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div class="col-md-6 col-xs-12 form-group form-email">
                <label for="email-id">Email</label>
                <span class="required_astric">*</span>
                <input
                  id="email-id"
                  class="form-control"
                  :class="{
                    'invalid-border': $v.user_data.email.$error || isFreeDomain
                  }"
                  type="text"
                  placeholder="Email"
                  v-model.trim="user_data.email"
                  maxlength="65"
                  @blur="checkEmailIsValid()"
                />
                <div v-if="$v.user_data.email.$error">
                  <div class="custom-error-class" v-if="!$v.user_data.email.required">
                    Complete required field
                  </div>
                  <div class="custom-error-class" v-else-if="!$v.user_data.email.isValidMail">
                    Invalid email format.
                  </div>
                </div>
                <div class="custom-error-class" v-else-if="isFreeDomain">
                  To combat fraudulent account creation, we have restricted certain domain email
                  addresses from creating new accounts.
                </div>
              </div>
              <div class="col-xs-12 col-md-6 form-group">
                <label for="title">Title</label>
                <input
                  id="title"
                  type="text"
                  class="form-control"
                  :class="$v.user_data.title.$error ? 'invalid-border' : ''"
                  placeholder="Title"
                  v-model.trim="user_data.title"
                  maxlength="50"
                  @blur="$v.user_data.title.$touch()"
                />
                <div
                  class="custom-error-class"
                  v-if="!$v.user_data.title.isAllowedCharacters && $v.user_data.title.$error"
                >
                  {{ specialCharacterErrMsg }}
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 form-group">
              <label>Area of Responsibility</label>
              <multiselect
                class="multiselect-single-dropdown"
                :class="!user_data.area_responsible_id ? 'un-selected' : ''"
                :show-labels="false"
                :allow-empty="false"
                :searchable="false"
                placeholder="Area of Responsibility"
                v-model="user_data.area_responsible_id"
                :options="responsibilitiesList.map((type) => type.id)"
                :custom-label="
                  (opt) => responsibilitiesList.find((x) => x.id === opt).responsibility_name
                "
              ></multiselect>
            </div>
          </div>
        </template>
        <!-- Company Details -->
        <template v-else-if="currentSlider == 1">
          <div class="col-md-6 col-sm-6 col-xs-12 map-img">
            <img
              src="/static/images/logos/RAMS_Dashboard_Logo.svg"
              class="rams-dashboard-logo"
              alt="rams-dashboard-logo"
            />
          </div>

          <div class="col-xs-12 col-md-6 col-sm-6 pl-0 xs-p-0">
            <div class="col-xs-12 account-details pb-10">
              <div class="info">Provide Company and address details below:</div>
              <el-popover
                placement="bottom-end"
                class="info-icon-class"
                trigger="click"
                popper-class="popup-background tootip-custom-small-width-class"
                @show="companyInfoActive = true"
                @hide="companyInfoActive = false"
              >
                <div class="content">
                  <ul class="word-break">
                    <li>
                      <span
                        >Please fill the mandatory details (if any) for all steps and they will be
                        available with “</span
                      >
                      <span class="mandatory-sign">*</span><span>” symbol.</span>
                    </li>
                    <li>
                      An organization can create multiple RAMS accounts using the same name;
                      however, duplicate account creation is not encouraged. Organization members
                      can be added to the same account and access shared premium services.
                    </li>
                  </ul>
                </div>
                <img
                  class="info-img ipad-right"
                  src="/static/images/icons/info_icon.svg"
                  v-if="!companyInfoActive"
                  alt="info-icon"
                  slot="reference"
                />
                <img
                  class="info-img"
                  src="/static/images/icons/info_icon_active.svg"
                  v-if="companyInfoActive"
                  alt="infoactive-icon"
                  slot="reference"
                />
              </el-popover>
            </div>
            <div class="col-xs-12 pb-10 note-text">
              <p>Note: State and Zip Code is mandatory for US only.</p>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="company_name">Company Name</label>
              <span class="required_astric">*</span>
              <input
                id="company_name"
                class="form-control"
                :class="[
                  $v.user_data.company.$error ? 'invalid-border' : ''
                ]"
                type="text"
                placeholder="Legal Company Name"
                v-model.trim="user_data.company"
                maxlength="50"
                @blur="
                  $v.user_data.company.$touch();
                  checkCompanyName();
                "
                @input="companyExists = false"
              />
              <div v-if="$v.user_data.company.$error">
                <div class="custom-error-class" v-if="!$v.user_data.company.required">
                  Complete required field
                </div>
                <div class="custom-error-class" v-else-if="!$v.user_data.company.minLength">
                  Minimum 2 characters required.
                </div>
                <div class="custom-error-class" v-else-if="!$v.user_data.company.isAlphaNum">
                  First character should be alphanumeric
                </div>
              </div>
              <div v-if="companyExists">
                <div class="custom-warning-class">Your company already exists in our system.</div>
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="country">Country</label>
              <span class="required_astric">*</span>
              <multiselect
                id="country"
                class="multiselect-single-dropdown"
                :class="{
                  'invalid-border': $v.user_data.country.$error,
                  'un-selected': !user_data.country
                }"
                placeholder="Select a country"
                label="country_name"
                v-model="user_data.country"
                :show-labels="false"
                :options="countriesList.map((type) => type.alpha_three_code)"
                :custom-label="
                  (opt) => countriesList.find((x) => x.alpha_three_code === opt).country_name
                "
              ></multiselect>
              <div
                class="custom-error-class"
                v-if="!$v.user_data.country.required && $v.user_data.country.$error"
              >
                Complete required field
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="street_address">Street Address</label>
              <input
                id="street_address"
                class="form-control"
                :class="$v.user_data.card_address.$error ? 'invalid-border' : ''"
                type="text"
                size="60"
                placeholder="Street Address"
                v-model="user_data.card_address"
                @blur="$v.user_data.card_address.$touch()"
              />
              <div
                class="custom-error-class"
                v-if="
                  !$v.user_data.card_address.isAllowedCharacters && $v.user_data.card_address.$error
                "
              >
                {{ specialCharacterErrMsg }}
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="phone_number">Phone Number</label>
              <input
                id="phone_number"
                class="form-control"
                :class="$v.user_data.mobile.$error ? 'invalid-border' : ''"
                type="text"
                size="15"
                maxlength="20"
                placeholder="Phone Number"
                v-model="user_data.mobile"
                @blur="$v.user_data.mobile.$touch()"
              />
              <div
                class="custom-error-class"
                v-if="!$v.user_data.mobile.isNumber && $v.user_data.mobile.$error"
              >
                Please enter only numbers
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="city">City</label>
              <input
                id="city"
                class="form-control"
                :class="$v.user_data.card_city.$error ? 'invalid-border' : ''"
                type="text"
                size="60"
                maxlength="50"
                placeholder="City"
                v-model="user_data.card_city"
                @blur="$v.user_data.card_city.$touch()"
              />
              <div v-if="$v.user_data.card_city.$error">
                <div class="custom-error-class" v-if="!$v.user_data.card_city.minLength">
                  Minimum 3 characters required.
                </div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.user_data.card_city.isAllowedCharacters"
                >
                  {{ specialCharacterErrMsg }}
                </div>
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="state">State</label>
              <span class="required_astric" v-if="user_data.country == 'USA'">*</span>
              <input
                id="state"
                class="form-control"
                :class="{
                  'invalid-border': !$v.user_data.card_state.isAllowedCharacters,
                  'valid-border':
                    !$v.user_data.card_state.$error && $v.user_data.country.$model != 'USA',
                  'mandatory-border':
                    $v.user_data.card_state.$error && $v.user_data.country.$model == 'USA'
                }"
                type="text"
                size="60"
                maxlength="50"
                placeholder="State"
                v-model="user_data.card_state"
                @blur="$v.user_data.card_state.$touch()"
              />
              <div v-if="$v.user_data.card_state.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.user_data.card_state.required && $v.user_data.country.$model == 'USA'"
                >
                  Complete required field
                </div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.user_data.card_state.isAllowedCharacters"
                >
                  {{ specialCharacterErrMsg }}
                </div>
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="zip_code">Zip / Postal Code</label>
              <span class="required_astric" v-if="user_data.country == 'USA'">*</span>
              <input
                id="zip_code"
                class="form-control"
                :class="{
                  'invalid-border': !$v.user_data.zipcode.isPostalCode,
                  'valid-border':
                    !$v.user_data.zipcode.$error && $v.user_data.country.$model != 'USA',
                  'mandatory-border':
                    $v.user_data.card_state.$error && $v.user_data.country.$model == 'USA'
                }"
                type="text"
                maxlength="15"
                placeholder="Zip / Postal Code"
                v-model.trim="user_data.zipcode"
                @blur="$v.user_data.zipcode.$touch()"
              />
              <div v-if="$v.user_data.zipcode.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.user_data.zipcode.required && $v.user_data.country.$model == 'USA'"
                >
                  Complete required field
                </div>
                <div class="custom-error-class" v-else-if="!$v.user_data.zipcode.minLength">
                  Minimum 2 characters required.
                </div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.user_data.zipcode.isPostalCode && user_data.zipcode"
                >
                  Valid Zip/Postal Code Required
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- password -->
        <template v-else-if="currentSlider == 2">
          <div class="col-md-6 col-sm-6 col-xs-12 map-img">
            <img
              src="/static/images/logos/RAMS_Dashboard_Logo.svg"
              class="rams-dashboard-logo"
              alt="rams-dashboard-logo"
            />
          </div>
          <div class="col-xs-12 col-md-6 col-sm-6 pl-0 xs-p-0">
            <div class="col-xs-12 account-details">
              <div class="info">Provide Password Details:</div>
              <el-popover
                placement="bottom-end"
                class="info-icon-class"
                trigger="click"
                popper-class="popup-background tootip-custom-small-width-class"
                @show="passwordInfoActive = true"
                @hide="passwordInfoActive = false"
              >
                <div class="content">
                  <ul class="word-break">
                    <li>
                      <span
                        >Please fill the mandatory details (if any) for all steps and they will be
                        available with “</span
                      >
                      <span class="mandatory-sign">*</span><span>” symbol.</span>
                    </li>
                    <li>Have at least one capital letter</li>
                    <li>Have at least one number</li>
                    <li>Have at least one special character !@#$.,+=( )_%^&*</li>
                    <li>Be at least 10 characters</li>
                  </ul>
                </div>
                <!-- <template #reference> -->
                <img
                  class="info-img"
                  src="/static/images/icons/info_icon.svg"
                  v-if="!passwordInfoActive"
                  alt="info-icon"
                  slot="reference"
                />
                <img
                  class="info-img"
                  src="/static/images/icons/info_icon_active.svg"
                  v-if="passwordInfoActive"
                  alt="infoactive-icon"
                  slot="reference"
                />
              </el-popover>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="password">Create Password</label>
              <span class="required_astric">*</span>
              <div class="password-flex">
                <input
                  ref="inputCreateTag"
                  id="password"
                  class="form-control eye"
                  :class="submitStatus == 'ERROR' && !user_data.password ? 'invalid-border' : ''"
                  type="password"
                  maxlength="65"
                  placeholder="Create Password"
                  v-model="user_data.password"
                  autocomplete="new-password"
                  @input="validate"
                />
                <img
                  v-if="showCreatePassword"
                  src="/static/images/icons/eye.svg"
                  class="eye-icon"
                  @click="toggleCreatePassword"
                  alt="eye-icon"
                />
                <img
                  v-if="!showCreatePassword"
                  src="/static/images/icons/eye_slash.svg"
                  class="eye-slash-icon"
                  @click="toggleCreatePassword"
                  alt="eye-icon"
                />
              </div>
              <div class="custom-error-class" v-if="submitStatus == 'ERROR' && !user_data.password">
                Please enter a password
              </div>
            </div>
            <div class="form-group col-xs-12 col-md-6">
              <label for="cpassword">Confirm Password</label>
              <span class="required_astric">*</span>
              <div class="password-flex">
                <input
                  ref="inputConfirmTag"
                  id="cpassword"
                  class="form-control eye"
                  :class="
                    (submitStatus == 'ERROR' && !user_data.cpassword) ||
                    user_data.password != user_data.cpassword
                      ? 'invalid-border'
                      : ''
                  "
                  type="password"
                  maxlength="65"
                  placeholder="Confirm Password"
                  v-model="user_data.cpassword"
                  value
                />
                <img
                  v-if="showConfirmPassword"
                  src="/static/images/icons/eye.svg"
                  class="eye-icon"
                  @click="toggleConfirmPassword"
                  alt="eye-icon"
                />
                <img
                  v-if="!showConfirmPassword"
                  src="/static/images/icons/eye_slash.svg"
                  class="eye-slash-icon"
                  @click="toggleConfirmPassword"
                  alt="eye-icon"
                />
              </div>
              <div
                class="custom-error-class"
                v-if="!user_data.cpassword && submitStatus == 'ERROR'"
              >
                Please confirm your password
              </div>
              <div
                class="custom-error-class"
                v-else-if="user_data.cpassword && user_data.password != user_data.cpassword"
              >
                Password does not match.
              </div>
            </div>
          </div>
        </template>
      </form>
    </div>
    <div class="col-xs-12 col-sm-offset-6 col-sm-6 footer pl-0 xs-p-0">
      <div class="col-xs-12" v-if="currentSlider == 2">
        <div class="d-flex" :class="!termsErr ? 'mb-20' : ''">
          <span class="checkbox mr-12">
            <label>
              <input
                type="checkbox"
                name="terms"
                id="checkbox-register"
                v-model="user_data.terms"
                @change="checkTerms()"
              />
              <span class="cr">
              </span>
            </label>
          </span>
          <div for="terms" class="terms-conditions">
            On behalf of my company, I agree to the
            <a class="term-priv" href="/terms-of-service">RAMS Software-as-a-Service Agreement</a>
          </div>
        </div>
        <div class="custom-error-class terms-err-class" v-if="termsErr">
          {{ termsErr }}
        </div>
      </div>
      <div class="col-xs-12 emergo-btns p-0 sm-pr-15 xs-p-0">
        <div class="col-sm-4 sm-pr-0 hidden-xs" v-if="currentSlider == 1 || currentSlider == 2">
          <button class="mb-10 emergo-white-button btn-block" @click="clearData">Cancel</button>
        </div>
        <div
          class="col-sm-4 sm-pr-0 visible-xs"
          :class="{
            'col-sm-offset-8': currentSlider !== 1 && currentSlider !== 2
          }"
        >
          <button
            class="mb-10 xs-mb-30 emergo-green-button btn-block"
            :disabled="submitStatus === 'PENDING'"
            @click="submitDetails()"
          >
            {{ currentSlider === 0 || currentSlider === 1 ? 'Next' : 'Sign Up' }}
          </button>
        </div>
        <div class="col-sm-4 sm-pr-0" v-if="currentSlider == 1 || currentSlider == 2">
          <button
            class="mb-10 xs-mb-30 emergo-white-button btn-block"
            :class="{ opacity: currentSlider === 0 }"
            :disabled="!currentSlider"
            @click="changeSlider"
          >
            Back
          </button>
        </div>
        <div
          class="col-sm-4 sm-pr-0 hidden-xs"
          :class="{
            'col-sm-offset-8': currentSlider !== 1 && currentSlider !== 2
          }"
        >
          <button
            class="mb-10 emergo-green-button btn-block"
            :disabled="submitStatus === 'PENDING'"
            @click="submitDetails()"
          >
            {{ currentSlider === 0 || currentSlider === 1 ? 'Next' : 'Sign Up' }}
          </button>
        </div>
        <div class="col-sm-4 sm-pr-0 visible-xs" v-if="currentSlider == 1 || currentSlider == 2">
          <button class="mb-10 xs-mb-30 mt-10 emergo-white-button btn-block" @click="clearData">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <verification-popup :successMessage="successMessage"></verification-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import { Popover } from 'element-ui';
import {
  getCountries,
  postRegister,
  GetResponsibilities,
  validateUserInfo,
  checkCompanyName
} from '../../apis/register';
import {
  isAllowedCharacters, // eslint-disable-line no-unused-vars
  isAlphaNum, // eslint-disable-line no-unused-vars
  isNumber, // eslint-disable-line no-unused-vars
  isPostalCode, // eslint-disable-line no-unused-vars
  validateData,
  isContainsUpperCase,
  isContainsLowerCase,
  isContainsDigit,
  isContainsSpecialChar,
  isValidMail, // eslint-disable-line no-unused-vars
  checkConditions
} from './validator';
import verificationPopup from '../VerificationLink/VerificationPopup.vue';
// import BasePopover from '../Common/BasePopover.vue';
import postMarketoFormData from '../../apis/marketo';

export default {
  components: {
    verificationPopup,
    // BasePopover,
    'el-popover': Popover
  },
  data() {
    return {
      showCreatePassword: true,
      showConfirmPassword: true,
      emergoContactBanner: true,
      currentSlider: 0,
      slidesInfo: [
        {
          title: 'Account Details'
        },
        {
          title: 'Company Details'
        },
        {
          title: 'Password'
        }
      ],
      user_data: {
        first_name: '',
        last_name: '',
        email: '',
        title: '',
        company: '',
        country: '',
        mobile: '',
        card_address: '',
        card_city: '',
        card_state: '',
        zipcode: '',
        password: '',
        cpassword: '',
        area_responsible_id: null,
        terms: false,
        repClient: 0,
        consultingClient: 0
      },
      clear_user_data: {
        first_name: '',
        last_name: '',
        email: '',
        title: '',
        company: '',
        country: '',
        mobile: '',
        card_address: '',
        card_city: '',
        card_state: '',
        zipcode: '',
        password: '',
        cpassword: '',
        area_responsible_id: null,
        terms: false,
        repClient: 0,
        consultingClient: 0
      },
      isFreeDomain: false,
      successMessage: '',
      countriesList: [],
      responsibilitiesList: [],
      btnTxt: 'Complete and Create account',
      submitStatus: null,
      termsErr: false,
      specialCharacterErrMsg: 'Characters not allowed are: * ? < > ! @ # $ “ % ^',
      counter: 0,
      verification: [
        { message: 'Have at least one capital letter', valid: false },
        { message: 'Have at least one lowercase letter', valid: false },
        { message: 'Have at least one number', valid: false },
        {
          message: 'Have at least one special character !@#$.,+=( )_%^&*',
          valid: false
        }
      ],
      isPasswordLength: false,
      passwordError: false,
      companyExists: false,
      companyInfoActive: false,
      emailInfoActive: false,
      passwordInfoActive: false,
      freeDomainNames: null
    };
  },
  validations: {
    user_data: validateData
  },
  async created() {
    if (this.$route.query) localStorage.setItem(`utmCodes`, JSON.stringify(this.$route.query));
    await this.loadCountries();
    await this.loadResponsibilites();
    if (sessionStorage.getItem('userData')) {
      this.user_data = JSON.parse(sessionStorage.getItem('userData'));
      this.validate();
    }
    this.user_data.plan =
      this.$route.query.plan === 'repclients' || this.$route.query.plan === 'consultingclients'
        ? this.$route.query.plan
        : '';
    const freeDomainImport = () => import('free-email-domains');
    this.freeDomainNames = await freeDomainImport();
  },
  methods: {
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
      if (!this.showConfirmPassword) {
        this.$refs.inputConfirmTag.type = 'text';
      } else {
        this.$refs.inputConfirmTag.type = 'password';
      }
    },
    toggleCreatePassword() {
      this.showCreatePassword = !this.showCreatePassword;
      if (!this.showCreatePassword) {
        this.$refs.inputCreateTag.type = 'text';
      } else {
        this.$refs.inputCreateTag.type = 'password';
      }
    },
    changeSlider() {
      if (this.currentSlider > 0) this.currentSlider -= 1;
    },
    submitDetails() {
      this.$v.$touch();
      const userObj = this.$v.user_data;
      if (
        this.currentSlider === 0 &&
        !userObj.first_name.$invalid &&
        !userObj.last_name.$invalid &&
        !userObj.email.$invalid
      ) {
        this.currentSlider += 1;
        this.$v.$reset();
      } else if (
        this.currentSlider === 1 &&
        !userObj.company.$invalid &&
        !userObj.country.$invalid &&
        userObj.card_address.isAllowedCharacters &&
        userObj.card_city.isAllowedCharacters &&
        userObj.card_state.isAllowedCharacters &&
        userObj.mobile.isNumber &&
        userObj.zipcode.isPostalCode
      ) {
        if (
          this.user_data.country === 'USA' &&
          !userObj.card_state.$invalid &&
          !userObj.zipcode.$invalid
        ) {
          this.currentSlider += 1;
          this.$v.$reset();
        } else if (this.user_data.country !== 'USA') {
          this.currentSlider += 1;
          this.$v.$reset();
        }
        this.submitStatus = null;
      } else if (this.currentSlider === 2) {
        this.submitStatus = 'ERROR';
        if (
          !this.passwordError ||
          this.user_data.password !== this.user_data.cpassword ||
          !this.user_data.cpassword
        ) {
          this.submitStatus = 'ERROR';
        } else if (!this.user_data.terms) {
          this.termsErr = 'You must accept the terms to create an account';
          this.btnTxt = 'Confirm and Create account';
        } else if (this.isFreeDomain) {
          this.submitStatus = 'ERROR';
        } else {
          this.submit();
        }
      }
    },
    async checkEmailIsValid() {
      this.$v.user_data.email.$touch();
      if (process.env.VUE_APP_MODE === 'production' && this.user_data.email.includes('@')) {
        const emailToSpit = this.user_data.email.split('@');
        const domainName = emailToSpit[emailToSpit.length - 1];
        this.isFreeDomain =
          this.$v.user_data.email.isValidMail && this.freeDomainNames.default.includes(domainName);
      }
    },
    async checkCompanyName() {
      if (!this.$v.user_data.company.$error) {
        this.companyExists = await checkCompanyName({
          company_name: this.user_data.company
        });
      }
    },
    dismissTab() {
      $('div.emergo-contact').remove();
      this.emergoContactBanner = false;
    },
    reset() {
      $('#divPasswordValidationResult').hide();
    },
    validate() {
      this.counter = 0;
      if (this.user_data.password) {
        this.verification[0].valid = isContainsUpperCase(this.user_data.password);
        this.verification[1].valid = isContainsLowerCase(this.user_data.password);
        this.verification[2].valid = isContainsDigit(this.user_data.password);
        this.verification[3].valid = isContainsSpecialChar(this.user_data.password);
      }
      this.counter = checkConditions(this.user_data.password);
      this.isPasswordLength = false;
      if (this.user_data.password.length >= 10) this.isPasswordLength = true;

      this.passwordError = false;
      if (this.isPasswordLength && this.counter >= 3) {
        this.passwordError = true;
      }
    },
    checkTerms() {
      this.termsErr = '';
      if (this.submitStatus && !this.user_data.terms) {
        this.termsErr = 'You must accept the terms to create an account';
      }
    },
    async submit() {
      this.submitStatus = 'PENDING';
      const validatedata = {
        email: this.user_data.email
      };
      if (this.user_data.plan) validatedata.plan = this.user_data.plan;
      const result = await validateUserInfo(validatedata);
      if (result && result.status) {
        this.termsErr = 'Email already registered.';
        this.submitStatus = null;
      } else if (result && !result.status) {
        this.submitStatus = 'PENDING';
        const country = this.countriesList.find(
          (item) => item.alpha_three_code === this.user_data.country
        );
        const data = this.user_data;
        const postData = {
          card_location: country ? country.country_name : '',
          alpha_three_code: country ? country.alpha_three_code : '',
          area_responsible_id: data.area_responsible_id,
          title: data.title,
          card_postal: data.zipcode,
          card_state: data.card_state,
          card_city: data.card_city,
          card_address: data.card_address,
          phone: data.mobile,
          company: data.company,
          email: data.email,
          first_name: data.first_name,
          last_name: data.last_name,
          password: data.password,
          terms: data.terms,
          plan: data.plan
        };
        Object.keys(postData).forEach((key) => {
          if (postData[key] === null || postData[key] === undefined || postData[key] === '') {
            delete postData[key];
          }
        });
        this.registrationFail = false;
        this.termsErr = '';
        this.btnTxt = 'Submitting Form...';
        const utmCodes = JSON.parse(localStorage.getItem('utm_codes'));
        const marketoForm = {
          form_id: 2800,
          input: [
            {
              lead_form_fields: {
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                phone: data.mobile,
                company: data.company,
                country: country ? country.country_name : '',
                last_interest: 'Market Access',
                page_url: window.location.href,
                page_url_referral: document.referrer,
                form_control: 'Complete and Create account'
              },
              visitor_data: {
                page_url: window.location.href
              }
            }
          ]
        };
        if (utmCodes) {
          marketoForm.input[0].lead_form_fields.gAKeyword = utmCodes.keyword;
          marketoForm.input[0].lead_form_fields.utmcampaign = utmCodes.utm_campaign;
          marketoForm.input[0].lead_form_fields.utmcontent = utmCodes.utm_content;
          marketoForm.input[0].lead_form_fields.utmmedium = utmCodes.utm_medium;
          marketoForm.input[0].lead_form_fields.utmmktoadid = utmCodes.utm_mktoadid;
          marketoForm.input[0].lead_form_fields.utmmktocampaign = utmCodes.utm_mktocampaign;
          marketoForm.input[0].lead_form_fields.utmsource = utmCodes.utm_source;
          marketoForm.input[0].lead_form_fields.utmterm = utmCodes.utm_term;
        }
        postMarketoFormData(marketoForm);
        const response = await postRegister(postData);
        this.btnTxt = 'Complete and Create account';
        this.submitStatus = null;
        if (response) {
          if (response.status) {
            this.clearData();
            this.successMessage = response.message;
            $('#successMsgModal').modal('show');
          } else {
            this.termsErr = response.message;
          }
        }
      }
    },
    clearData() {
      this.currentSlider = 0;
      this.user_data = {
        first_name: '',
        last_name: '',
        email: '',
        title: '',
        company: '',
        country: '',
        mobile: '',
        card_address: '',
        card_city: '',
        card_state: '',
        zipcode: '',
        password: '',
        cpassword: '',
        area_responsible_id: null,
        terms: false,
        repClient: 0,
        consultingClient: 0
      };
      this.$v.$reset();
      this.validate();
    },
    async loadCountries() {
      this.countriesList = await getCountries();
    },
    async loadResponsibilites() {
      this.responsibilitiesList = await GetResponsibilities();
    }
  },
  watch: {
    user_data: {
      deep: true,
      handler(userData) {
        sessionStorage.setItem('userData', JSON.stringify(userData));
        if (userData.country) {
          const selectedCountry = this.countriesList.find(
            (x) => x.alpha_three_code === userData.country
          );
          this.opt_in_type = selectedCountry.opt_in;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin emergoGreenBtnProps {
  background: $light-green !important;
  border-color: $light-green !important;
  color: $deep-white !important;
  outline: none;
}
@mixin emergoWhiteBtnProps {
  background-color: $deep-white;
  border: 1px solid $primary;
  color: $primary;
  outline: none;
}
.container {
  width: 100%;
}
.emergo-contact {
  background: $deep-white;
  box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.27);
  border-radius: $radius10;
  padding-left: 17px;
  padding-right: 6px;
}
.map-img {
  padding-top: 80px;
}
.account-details {
  padding-top: 55px;
  padding-bottom: 20px;
  display: flex;
  .info {
    font-style: normal;
    font-weight: $font-weight-400;
    font-size: $font-18;
    line-height: 21px;
    color: $dark-black-alpha;
  }
  &.pb-10 {
    padding-bottom: 10px;
  }
  .info-img {
    position: absolute;
    right: 25px;
  }
}
.close-icon {
  position: absolute;
  top: 24px;
  right: 20px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.el-popover {
  .content {
    font-style: normal;
    font-weight: $font-weight-400;
    font-size: $font-18;
    line-height: 24px;
    color: $dark-black-alpha;
    text-align: left;
    ul {
      li {
        &:not(:first-child) {
          padding-top: 10px;
        }
      }
    }
  }
}
.emergo-info {
  display: flex;
  padding-top: 13px;
}
.country-representation {
  font-style: normal;
  font-weight: $font-weight-medium;
  font-size: $font-22;
  line-height: 26px;
  color: $primary;
  padding-top: 24px;
}
.emergo-contact-pd {
  padding: 52px 42px 22px 40px;
}
.emergo-contact-removed {
  padding: 12px 42px 20px 40px;
}
.active-account {
  font-style: normal;
  font-weight: $font-weight-400;
  font-size: $font-16;
  line-height: 19px;
  color: $dark-black-alpha;
  padding-right: 15px;
  .fw-500 {
    font-weight: $font-weight-medium;
  }
}
.emergo-img {
  padding-right: 32px;
  img {
    width: 121px;
    height: 35px;
  }
}
.contact-emergo {
  font-style: normal;
  font-weight: $font-weight-medium;
  font-size: $font-18;
  line-height: 21px;
  text-align: right;
  color: $messenger-blue;
  margin-bottom: 20px;
  a {
    color: $messenger-blue;
  }
}
.required_astric {
  color: $red;
}
.form-group {
  margin-bottom: 40px;
  .form-control {
    margin-top: 0px;
  }
  label {
    padding-right: 5px;
    margin-bottom: 8px;
  }
}
.rams-dashboard-logo {
  width: 700px;
  height: 425px;
}
.valid-border {
  border-color: $black !important;
}
.custom-error-class {
  margin-bottom: -20px;
  padding-top: 6px;
}
.flex-container {
  justify-content: left;
}
.emergo-btns {
  &.txt-algn-right {
    text-align: right;
  }
}
.emergo-white-button {
  margin-right: 24px;
  padding-top: 7px;
  padding-bottom: 7px;
}
.emergo-green-button {
  font-style: normal;
  @include fontItems($font-18, 21px, $font-weight-medium);
  background: $light-green;
  border: 1px solid $light-green;
  border-radius: $radius20;
  color: $deep-white;
  padding-top: 7px;
  padding-bottom: 7px;
}
.emergo-green-button {
  &:hover {
    &:not(:disabled) {
      @include emergoGreenBtnProps();
    }
  }
  &:active,
  &.active {
    &:hover {
      &:not(:disabled) {
        @include emergoGreenBtnProps();
      }
    }
  }
  &:focus,
  &:focus-visible {
    @include emergoGreenBtnProps();
  }
}
.emergo-white-button {
  &:focus,
  &:focus-visible {
    @include emergoWhiteBtnProps();
  }
  &:active,
  &:active:focus,
  &:active.focus {
    @include emergoWhiteBtnProps();
  }
  &.active.focus,
  &.active:focus {
    @include emergoWhiteBtnProps();
  }
  &:hover {
    &:not(:disabled) {
      background: transparent;
    }
  }
  &:active {
    &:hover {
      &:not(:disabled) {
        background: transparent;
      }
    }
  }
}
.emergo-green-button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.terms-conditions {
  font-style: normal;
  @include fontItems($font-14, 16px, $font-weight-400);
  color: $black;
}
.term-priv {
  color: $messenger-blue;
  font-size: $font-14;
  font-weight: $font-weight-600;
}
.terms-err-class {
  margin-bottom: 20px;
  margin-left: 35px;
}
.check-content {
  display: grid;
  justify-content: right;
}
.note-text {
  font-style: normal;
  @include fontItems($font-14, 16px, $font-weight-medium);
  color: $dark-black-alpha;
}
.crumb-trail {
  margin-top: 20px;
  list-style: none;
  padding: 0px 10px;
  & > li {
    &.is-active-slide {
      & + li {
        & > .crumb {
          &:after {
            border-left-color: $primary;
          }
        }
      }
    }
    &:first-child {
      & > .crumb {
        border-top-left-radius: 40px;
        border-bottom-left-radius: 40px;
      }
    }
    &:last-child {
      & > .crumb {
        border-top-right-radius: 40px;
        border-bottom-right-radius: 40px;
      }
    }
    &:not(:first-child) {
      & > .crumb {
        margin-left: 10px;
      }
    }
  }
}
.completed_slide {
  & > .crumb {
    & > .breadcrumb-img {
      display: inline;
    }
  }
}
.breadcrumb-img {
  vertical-align: top;
  margin-right: 6px;
  height: 23px;
  width: 23px;
  display: none;
}
.crumb {
  font-style: normal;
  @include fontItems($font-20, 23px, $font-weight-normal);
  color: $deep-gray;
  padding: 20px;
  position: relative;
  cursor: pointer;
  background: #f3f5fa;
  text-align: center;
}
.is-active-slide {
  & > .crumb {
    background: $primary;
    color: $deep-white;
  }
}
li {
  &:not(:first-child) {
    & > .crumb {
      &:after {
        content: '';
        border-top: 30px solid transparent;
        border-bottom: 33px solid transparent;
        border-left: 24px solid #f3f5fa;
        position: absolute;
        left: -10px;
        top: 0;
        z-index: 1;
      }
      &:before {
        content: '';
        border-top: 30px solid transparent;
        border-bottom: 33px solid transparent;
        border-left: 24px solid $white;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
}
.hide-xs {
  display: inline;
}
.show-xs {
  display: none;
}
.password-flex {
  display: flex;
  input {
    padding: 6px 40px 6px 12px;
  }
}
.eye-icon,
.eye-slash-icon {
  margin-top: 9px;
}
@media (width: 768px) {
  .crumb {
    & > .breadcrumb-img {
      vertical-align: middle;
      margin-right: 2px;
      height: 18px;
      width: 18px;
    }
  }
  .crumb-trail {
    & > li {
      & > .crumb {
        font-size: 15px;
        padding: 20px 5px 20px 28px;
      }
    }
  }
  .sm-pr-0 {
    padding-right: 0;
  }
  .sm-pr-15 {
    padding-right: 15px !important;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .crumb-trail {
    & > li {
      & > .crumb {
        font-size: $font-16;
        padding: 20px 0px 20px 28px;
      }
    }
  }
  .sm-pr-0 {
    padding-right: 0;
  }
  .sm-pr-15 {
    padding-right: 15px !important;
  }
}
@media screen and (max-width: 1024px) {
  .crumb-trail {
    & > li {
      &:not(:first-child) {
        & > .crumb {
          &:after {
            left: -11px;
          }
          &:before {
            left: -1px;
          }
        }
      }
      &:not(:last-child).is-active-slide {
        & > .crumb {
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .crumb-selection {
    padding: 0px;
  }
  .crumb-trail {
    padding: 0px;
    & > li {
      &.completed_slide {
        & > .crumb {
          padding: 8px;
        }
      }
      &:not(:first-child).completed_slide {
        & > .crumb {
          padding: 8px 0px 8px 0px;
          text-align: right;
        }
      }
      & > .crumb {
        font-size: 0px;
        padding: 12px;
      }
      &.is-active-slide {
        & > .crumb {
          font-size: 16px;
        }
        & + li {
          & > .crumb {
            &:after {
              border-left-color: $primary;
            }
          }
        }
      }
      &:not(:first-child) {
        & > .crumb {
          &:after {
            border-top: 22px solid transparent;
            border-bottom: 24px solid transparent;
            border-left: 16px solid #f3f5fb;
          }
          &:before {
            border-top: 22px solid transparent;
            border-bottom: 25px solid transparent;
            border-left: 16px solid $white;
          }
        }
      }
    }
  }
  .completed_slide {
    & > .crumb {
      & > .breadcrumb-img {
        margin-right: 0px;
        height: 30px;
        width: 30px;
      }
    }
  }
  .emergo-contact-pd {
    padding: 20px;
  }
  .country-representation {
    width: calc(100% - 15px);
  }
  .close-icon {
    right: 10px;
  }
  .container {
    overflow-x: hidden;
  }
  .map-img {
    padding-top: 50px;
  }
  .rams-dashboard-logo {
    width: 400px;
    height: 350px;
    position: relative;
    right: 20px;
  }
  .account-details {
    padding-top: 0px;
    .info-img {
      right: 0px;
    }
  }
  .emergo-info {
    display: block;
  }
  .emergo-img {
    padding-right: 0px;
    padding-bottom: 17px;
  }
  .show-xs {
    display: inline;
  }
  .hide-xs {
    display: none;
  }
  .footer {
    padding-left: 0px;
    display: flex;
    flex-direction: column;
  }
  .emergo-white-button {
    &.plr-45 {
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }
  }
  .emergo-green-button {
    &.plr-55 {
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
    }
  }
  .encrypt_logo {
    width: 85px;
    height: 19px;
    margin-right: 0px;
  }
  .azure_logo {
    width: 105px;
    height: 23px;
    margin-right: 0px;
  }
  .azr_security_logo {
    width: 19px;
    height: 19px;
  }
  .azure_security_text {
    font-size: 12px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .xs-p-0 {
    padding: 0;
  }
  .xs-mb-30 {
    margin-bottom: 30px;
  }
}
@media (min-width: 540px) and (max-width: 767px) {
  .rams-dashboard-logo {
    width: 550px;
    right: 0px;
  }
}

@media (min-width: 768px) and (max-width: 1115px) {
  .rams-dashboard-logo {
    width: 425px;
    height: 459x;
  }
  .account-details .info-img.ipad-right {
    right: -10px;
  }
}

@media (min-width: 992px) and (max-width: 1292px) {
  .custom-warning-class {
    line-height: 12px;
  }
}
</style>
